gfHandler = {
    btnAddEmployer: '#btn-add-employer',
    $dataEmployerContainer: $('#data-employer-container'),
    $gformWrapper: $('.gform_wrapper'),
    $inputOther: $('#input_4_5_other'),
    $htmlTemp: null,
    $htmlUploadTemp: [],
    files: [],

    generateSelect: function() {
        $('body').find('select:not(.select-hidden)').each(function(e){
            var $this = $(this), numberOfOptions = $(this).children('option').length;
            var $name = $this.attr('name');
            
            $this.parent().parent().addClass($name);
            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled button-caret-down-red wider bigger"></div>');
                
            var $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.children('option').eq(0).text());
        
            var $list = $('<ul />', {
                'class': 'select-options' 
            }).insertAfter($styledSelect);
        
            for (var i = 0; i < numberOfOptions; i++) {
                if ($this.children('option').eq(i).is(':selected')) {
                    $styledSelect.text($this.children('option').eq(i).text());
                }
            }
        
            $styledSelect.on("click", function(e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function(){
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                var $selectOptions = $(this).closest('.select').find('.select-options').empty();
                for (var i = 0; i < numberOfOptions; i++) {
                    if ( $this.children('option').eq(i).text() !== '') {
                        var liProps = {
                            text: $this.children('option').eq(i).text(),
                            rel: $this.children('option').eq(i).val(),
                            class: ($this.children('option').eq(i).attr('disabled') ? 'disabled' : '') + $this.children('option').eq(i).val(),
                        };
                        $('<li />', liProps).appendTo($selectOptions);
                    }
                }			
                $selectOptions.find('li').on("click", function(e) {
                    e.stopPropagation();
                    if (!$(e.target).is('.disabled')) {
                        $styledSelect.removeClass('active');
                        $this.val($(this).attr('rel')).trigger("change");
                        $selectOptions.hide();		
                    }
                });	
                $(this).toggleClass('active').next('ul.select-options').toggle();
                $(this).addClass('value-selected');
            })  
        
            $this.on("change", function() {
                var currentValue = $this.val();
                $styledSelect.removeClass('selected');
                for (var i = 0; i < numberOfOptions; i++) {
                    if ($this.children('option').eq(i).attr('value') == currentValue) {
                        $styledSelect.text($this.children('option').eq(i).text());
                        if ($this.children('option').eq(i).val()) {
                            $styledSelect.addClass('selected');
                        }
                    }
                }	
            });
        
            $(document).on("click", function() {
              $styledSelect.removeClass('active');
              $list.hide();
            })
        });
        $('body').find('select').each(function(e){
            let selectedVal = null;
            $(this).children().each(function(obj){
                let sval = $(this).attr('value');
                if ( (sval) && ($(this).attr('selected')) ) {
                    selectedVal = sval;
                }
            })
            if (selectedVal) {
                $(this).next().addClass('selected');
            }
        })
    },

    templateUpload: function(){
        var self = this;
        self.$gformWrapper.find('.upload-file').each(function(i){
            if (self.$htmlUploadTemp[i] == null) {
                $(this).html(
                    '<div class="grid-x grid-input">'+
                        '<div class="cell input-field">'+
                            '<input type="file" class="input_file hide" id="input_file_'+i+'" data-id="'+i+'" name="file_upload[]" size="25" accept=".jpg,.png,.giv,.mov" />'+
                            '<label class="label-input" data-id="'+i+'" for="input_file_'+i+'">Upload file</label>'+
                            '<span class="clear-img" data-id="'+i+'" ></span>'+
                        '</div>'+
                    '</div>'
                )
            } else {
                $(this).html(
                    self.$htmlUploadTemp[i]
                )
                $(this).find('.input_file')[0].files = self.files[i];
            }
        });   
    },

    clearItems: function(id){
        var $currInputFile = $('.input_file[data-id="'+id+'"]');
        var $currInputFileText = $('.file-label[data-id="'+id+'"]');
        var $labelInput = $('.label-input[data-id="'+id+'"]');
        
        $currInputFile.val('');
        $currInputFileText.val('');
        $labelInput.text('Upload file');
        $currInputFile.parent().removeClass('selected');
    
        if (file_only == false) { 
            var $uploadsItem = $('.uploads-item[data-id="'+id+'"]');
            var $textareaUploads =  $('.textarea-uploads[data-id="'+id+'"]');
    
            $textareaUploads.val('');
            $uploadsItem.removeClass('selected');
            $uploadsItem.addClass('input');
        } 
    },

    getFilename: function(id){
        var self = this;
        var $obj = self.$gformWrapper.find('.input_file[data-id="'+id+'"]');
        if ($obj) {
            var tmpName = $obj.val().split('\\').pop();
            var file = $obj[0].files[0];
            var totalSizeMb = 0;
            if (file !== undefined) {
                totalSizeMb = file.size  / Math.pow(1024,2);
                if (totalSizeMb > 4) {
                    alert("Please keep your uploaded file under 4MB in size.");
                    self.clearItems(id, true);
                    return "";
                } 
            }
            if (tmpName != '') {
                return tmpName ;// + ' (' + totalSizeMb.toFixed(2) + ' MB)';
            } else {
                return "";
            }
        } else {
            return "";
        }
    },

    inputHandler: function(id, filename) {
        var self = this;
        var $labelInput = $('.label-input[data-id="'+id+'"]');
        var $currInputFile = $('.input_file[data-id="'+id+'"]');
        
        $labelInput.html('<span>'+filename+'</span>');
        $labelInput.parent().addClass('selected');
    
        if (filename == '') {
            $labelInput.text('Upload file');
            $labelInput.parent().removeClass('selected');
        } 
        var $parent =  $labelInput.closest('.upload-file').html();
        self.$htmlUploadTemp[id] = $parent;
        self.files[id] = $currInputFile[0].files;
    },

    numericInput: function(inp) {
        var locale = 'en-US';
        var numericKeys = '0123456789';
      
        inp.addEventListener('keypress', function(e) {
            var event = e || window.event;
            var target = event.target;
        
            if (event.charCode == 0) {
                return;
            }
        
            if (-1 == numericKeys.indexOf(event.key)) {
                event.preventDefault();
                return;
            }
        });
      
        inp.addEventListener('blur', function(e) {
            var event = e || window.event;
            var target = event.target;
        
            var tmp = target.value.replace(/,/g, '');
            var val = Number(tmp).toLocaleString(locale);
        
            if (tmp == '') {
                target.value = '';
            } else {
                target.value = val;
            }
        });
      
        inp.addEventListener('focus', function(e) {
            var event = e || window.event;
            var target = event.target;
            var val = target.value.replace(/[,.]/g, '');

            target.value = val;
        });
    },

    previousFormClick: function(){
        var self = this;
        self.$gformWrapper.on('click', '.gf_step_completed', function(e){
            e.preventDefault();
            e.stopPropagation();
            var id = $(this).attr('id');
            var idx = parseInt(id.substr(id.length - 1)) + 1;
            var $gformPage = self.$gformWrapper.find('#gform_page_3_'+idx);
            $gformPage.find('.gform_previous_button').click();
        }) 
    },

    inputTypeNumber: function(){
        var self = this;
        self.$inputOther = self.$gformWrapper.find('#input_4_5_other'),
        self.$inputOther.prop("disabled", false);
        self.$inputOther.val('');
        self.$inputOther.attr('type', 'number');
        self.$inputOther.on('click', function(){
            $(this).closest('.gchoice ').find('.gfield-choice-input').click();
        });

        $('#input_4_5').on('click', 'label', function(){
            setTimeout(() => {
                self.$inputOther.prop("disabled", false);
                self.$inputOther.val('');
            }, 300);
        })
    },

    init: function(){
        var self = this;

        jQuery(document).on('gform_post_render', function(event, form_id, current_page){
            self.generateSelect();
            self.templateUpload();
            self.inputTypeNumber();

            if (self.$htmlTemp != null) {
                self.$gformWrapper.find('#data-employer-container').html(self.$htmlTemp);
            } 

            //handle number text
            self.$gformWrapper.find('.type-money').find('input.large').addClass('input-type-money').attr({
                'type': 'text',
                'min': '0'
            });

            self.$gformWrapper.find('.type-money').find('input.input-type-money').on("keypress", function (evt) {
                if ((evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) || (evt.which == 38 || evt.which == 40 )) {
                    evt.preventDefault();
                }
            });

            self.$gformWrapper.find('.type-money').find('input.input-type-money').each(function(){
                self.numericInput(this);
            })

            if (form_id === 4) {
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 200);
            } 

            //handle previous click
            self.previousFormClick();

            
            var $dataEmployerContainer = self.$gformWrapper.find('#data-employer-container'); 
            var nextNo = $dataEmployerContainer.children().length+1;
            var $empCount = self.$gformWrapper.find('.employer-count');
            if ($empCount) {
                $empCount.html(nextNo);
            }
        });

        self.$gformWrapper.on('change', 'input.input_file', function() {
            var id = this.getAttribute('data-id');
            var filename = self.getFilename(id);
            self.inputHandler(id, filename);
        });

        self.$gformWrapper.on('click', '.clear-img', function(e) {
            var id = this.getAttribute('data-id');
            $(this).parent().removeClass('selected');
            self.clearItems(id, true);
            self.inputHandler(id, '');
        }); 

        

        self.$gformWrapper.on('change', 'input.input-type-money', function(){
            var totals = 0;
            if ($(this).closest('#gform_fields_3_5').length > 0) {
                self.$gformWrapper.find('#gform_fields_3_5').children().each(function(){
                    var $input = $(this).find('input.input-type-money');
                    if ($input) {
                        var val = $input.val();
                        if (val != undefined) {
                            val = val.replace(',', '');
                        }
                        if (val > 0) {
                            totals += parseInt(val);
                        }
                    }
                })
                self.$gformWrapper.find('#input_3_105').val(totals)
                self.$gformWrapper.find('span.total').text(totals);

            } else {
                self.$gformWrapper.find('#gform_fields_3_6').children().each(function(){
                    var $input = $(this).find('input.input-type-money');
                    var id = $input.attr('id');
                    if ((id == 'input_3_91') || (id == 'input_3_92')) {
                        return false;
                    }

                    if ($input) {
                        var val = $input.val();
                        if (val > 0) {
                            totals += parseInt(val);
                        }
                    }
                })
                self.$gformWrapper.find('#input_3_104').val(totals)
                self.$gformWrapper.find('span.total-2').text(totals);
    
            }
        })

        self.$gformWrapper.on('click', '.btn-add-employer', function(){
            var $parentForm = $(this).closest('.gform_fields');
            var $dataEmployerContainer = $parentForm.find('#data-employer-container'); 
            var $employeeItem = $('<li />', {'class': 'employee-item'}).appendTo($dataEmployerContainer);
            //var i = 0;
            var datas = '';
            var nextNo = $dataEmployerContainer.children().length;
            var isDataAdded = false;
            $employeeItem.html('<div class="eyebrow color-dark-yellow title">Employer '+$dataEmployerContainer.children().length+'</div>');
            $parentForm.children().each(function(i, v){
                if ((i > 1) && (i < 9)) {
                    var name = $(this).find('.gfield_label').text();
                    var val = $(this).find('input').val();
                    if ((i == 2) && (val == "")) {
                        $employeeItem.remove();
                        return false;
                    } else {
                        isDataAdded = true;
                    }
                    var itemProps = {
                        class: 'gfield'
                    };
                    var $obj = $('<div />', itemProps).appendTo($employeeItem);
                    
                    $( $(this).html() ).appendTo($obj);
                    $obj.find('input').attr('value', val);

                    $(this).find('input').val('');
                    datas += val+'^';
                }   
            })    
            $('<input type="hidden" name="field_employer[]" value="'+datas+'"/>').appendTo($employeeItem);
            self.$htmlTemp = $dataEmployerContainer.html();     
            if (isDataAdded) {
                nextNo++;
            } 
            $parentForm.find('.employer-count').html(nextNo);
            
            $('html, body').animate({
                scrollTop: $('#data-employer-container').offset().top
            }, 500);
        })

        self.$gformWrapper.on('change', '.employee-item', function(){
            var datas = "";
            $(this).children().each(function(){
                var val = $(this).find('input').val();
                datas += val+'^';
            })
            $(this).find('input[type="hidden"]').attr('value', datas);
        });
        
    }
}